var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1069 14.2811C31.6284 16.1053 31.6853 18.5157 31.2775 21.5122C30.8784 24.4449 29.9486 27.1755 28.4883 29.7041C27.0367 32.1688 25.316 34.2074 23.3262 35.8198C19.2448 39.2253 14.9557 40.6222 10.4589 40.0102C6.11326 39.4188 3.28948 37.1189 1.98758 33.1105C1.29143 30.8728 1.13856 28.3196 1.529 25.4507C2.30123 19.7765 4.70605 14.9739 8.74345 11.0428C12.7809 7.1117 17.1802 5.47015 21.9416 6.11814C26.7407 6.77127 29.7957 9.49225 31.1069 14.2811Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9123 13.418C36.1222 13.4222 36.3213 13.4606 36.5201 13.5551C36.7252 13.6532 36.9057 13.801 37.0421 13.9829C37.1107 14.0762 37.1316 14.1162 37.0421 13.9829C37.225 14.2268 37.3246 14.5254 37.3246 14.8302C37.3209 14.7224 37.324 14.755 37.3246 14.8302V36.0145C37.3246 36.7944 36.6923 37.4267 35.9123 37.4267H7.66668C6.88669 37.4267 6.25439 36.7944 6.25439 36.0145V14.8302C6.25439 14.5774 6.32298 14.3264 6.45201 14.1095C6.71493 13.6665 7.17034 13.428 7.66668 13.418H35.9123ZM34.5 17.6548L22.6369 26.5522C22.1849 26.8911 21.5805 26.925 21.098 26.6539L20.9421 26.5522L9.07896 17.6548V34.6022H34.5V17.6548ZM11.9035 16.2425L21.7895 23.657L31.6754 16.2425H11.9035Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.75a4d83512ba2ce180083545528bf3e4.svg";
export { ForwardRef as ReactComponent };